define('lq/validatorGateway',[
    'underscore'
], function (_) {

    var callbacks = [];

    return {

        loadValidator: function () {
            if (!window.validator) 
                postMessage({type: "LOAD_VALIDATOR"}, '*');;    
        },

        isEnabled: function () {
            return !!window.validator;    
        },

        publishEvent: function (theEvent) {
            if (!window.validator) return;
            window.validator.gateway.publishEvent(theEvent);
        },

        registerListener: function (instanceId, callback) {
            if (!window.validator) return;
            window.validator.gateway.registerListener(instanceId, callback);
        },

        unregisterListener: function (instanceId) {
            if (!window.validator) return;
            window.validator.gateway.unregisterListener(instanceId);
        },

        whenEnabled: function (callback) {
            callbacks.push(callback);
        },

        callCallbacks: function () {
            callbacks.forEach(function (callback) {
                callback();
            });

            callbacks = [];
        },

        removeCallback: function (callbackToRemove) {
            callbacks = callbacks.filter(function (callback) {
                return callback !== callbackToRemove;
            });
        },

    };

});
